import { CommonModule, DatePipe } from '@angular/common'
import { Component, OnInit } from '@angular/core'
import { AuthStateService } from '../../auth-state.service'
import { Router, RouterOutlet } from '@angular/router'
import { AuthService } from '../../auth.service'
import { UserModel } from '../users/user_model'
import { MasterCommonServices } from '../quotation/master.common.service'
import { WorkOrderService } from '../workOrder/workOrder.service'
import { FormsModule } from '@angular/forms'
import { InvoiceService } from '../workOrder/invoice.service'

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
})
export class HomeComponent implements OnInit {
  userInfo: UserModel | undefined
  isLoggedIn: boolean | null = null
  itemList: Array<any> = []
  pendingWorkOrders: any[] = []
  permissions: string[] = []
  filter = {
    woId: '',
    poId: '',
    date: '',
    workOrderCompany: '',
    invoiceStatus: '',
    stickerStatus: '',
    tcStatus: '',
    operationsStatus: '',
  }
  filteredPendingWorkOrders: any[] = []
  revealedCompanies: Set<number> = new Set()

  constructor(
    public workOrderCommonServices: MasterCommonServices,
    private workOrderService: WorkOrderService,
    private authService: AuthService,
    private authStateService: AuthStateService,
    public router: Router,
    private invoiceService: InvoiceService,
  ) {}

  ngOnInit(): void {
    this.authStateService.userEvent.subscribe((user) => {
      if (user !== null) {
        this.userInfo = user
      }
    })

    this.authStateService.permissions.subscribe((permList) => {
      this.permissions = permList
    })

    if (this.workOrderCommonServices.clientsList.length === 0) {
      this.workOrderCommonServices.getAllClients()
    }
    this.getPendingWorkOrders()
  }

  get canViewInvoice(): boolean {
    return this.permissions.includes('WorkOrdersStatusInvoicePermission')
  }
  get canViewSticker(): boolean {
    return this.permissions.includes('WorkOrdersStatusStickerPermission')
  }
  get canViewTC(): boolean {
    return this.permissions.includes('WorkOrdersStatusTCPermission')
  }
  get canViewOperations(): boolean {
    return this.permissions.includes('WorkOrdersStatusOperationsPermission')
  }
  get pendingCount(): number {
    return this.filteredPendingWorkOrders.filter(
      (wo) => !wo.status || wo.status === 'ongoing',
    ).length
  }

  onItemSelected(item: any) {
    this.router.navigateByUrl(item.link)
  }

  logout(): void {
    this.authService.logout()
    this.authStateService.setLoggedIn(false)
  }

  getPendingWorkOrders(): void {
    this.workOrderService.getAllWorkOrdersStatus().subscribe((orders) => {
      this.pendingWorkOrders = (orders || []).filter(
        (wo: any) => !this.isCompleted(wo),
      )
      this.filteredPendingWorkOrders = [...this.pendingWorkOrders]
    })
  }

  applyFilters() {
    this.filteredPendingWorkOrders = this.pendingWorkOrders.filter((wo) => {
      const clientName =
        this.workOrderCommonServices
          ?.getClientName(wo.workOrderCompanyId)
          ?.companyName?.toLowerCase() || ''

      const workOrderNumber = (wo.workOrderNumber || '')
        .toString()
        .toLowerCase()
      const purchaseOrderNumber = (wo.purchaseOrderNumber || '')
        .toString()
        .toLowerCase()

      const invoiceStatus = wo.invoiceUpdatedBy ? 'Done' : 'Pending'
      const stickerStatus = wo.stickerUpdatedBy ? 'Done' : 'Pending'
      const tcStatus = wo.tcUpdatedBy ? 'Done' : 'Pending'
      const operationsStatus = wo.operationsUpdatedBy ? 'Done' : 'Pending'

      return (
        (!this.filter.woId ||
          workOrderNumber.includes(this.filter.woId.toLowerCase())) &&
        (!this.filter.poId ||
          purchaseOrderNumber.includes(this.filter.poId.toLowerCase())) &&
        (!this.filter.date ||
          new Date(wo.workOrderDate)
            .toLocaleDateString('en-GB')
            .includes(this.filter.date)) &&
        (!this.filter.workOrderCompany ||
          clientName.includes(this.filter.workOrderCompany.toLowerCase())) &&
        (!this.filter.invoiceStatus ||
          invoiceStatus === this.filter.invoiceStatus) &&
        (!this.filter.stickerStatus ||
          stickerStatus === this.filter.stickerStatus) &&
        (!this.filter.tcStatus || tcStatus === this.filter.tcStatus) &&
        (!this.filter.operationsStatus ||
          operationsStatus === this.filter.operationsStatus)
      )
    })
  }

  resetFilters(): void {
    this.filter = {
      woId: '',
      poId: '',
      date: '',
      workOrderCompany: '',
      invoiceStatus: '',
      stickerStatus: '',
      tcStatus: '',
      operationsStatus: '',
    }
    this.filteredPendingWorkOrders = this.pendingWorkOrders
  }

  isCompleted(wo: any): boolean {
    
    return (
      wo.invoiceUpdatedBy &&
      wo.stickerUpdatedBy &&
      wo.tcUpdatedBy &&
      wo.operationsUpdatedBy
    )
  }

  navigateToWorkOrder(workOrderNumber: string): void {
    this.router.navigate(['/viewWorkOrdersStatus'], {
      state: { highlightWoNumber: workOrderNumber },
    })
  }

  toggleCompanyVisibility(workOrderId: number): void {
    if (this.revealedCompanies.has(workOrderId)) {
      this.revealedCompanies.delete(workOrderId)
    } else {
      this.revealedCompanies.add(workOrderId)
    }
  }

  generateInvoice(workOrderId: number): void {
    this.workOrderService
      .getWorkOrderById(workOrderId)
      .subscribe((workOrder) => {
        if (workOrder) {
          this.invoiceService.generateInvoice(
            workOrder,
            this.workOrderCommonServices,
            new DatePipe('en-GB'),
          )
        }
      })
  }
}
